'use strict';

import baseApi from './base-api';
import moment from 'moment'

export default class SmallGenreApi extends baseApi {  
  getArticles(genre, smallGenre, page = 1, perPage = 20) {
    let params = {
          'page': page,
          'par_page': perPage,
        },
        domain = window.location.protocol + '//' + window.location.host,
        result = this.getApiRequest(domain + `/api/smallgenre/article/${genre}/`, params);
        
        return result;
  }
}